import { render } from "./ConfirmNewPassword.vue?vue&type=template&id=04ac74dd"
import script from "./ConfirmNewPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__